/**
 * Removes trailing slashes from a URL or path segment (typical for HTTP API base URLs).
 */
export function trimTrailingSlashes(url: string): string {
  return url.replace(/\/+$/, '');
}
